export const normalizeText = (...texts: string[]) => texts.join('') + ' ';
